import { element, kitIcon } from './kit.js';
import './achievement-toast.css';
import './quests.css';

/** How long one notice stays on screen before the next takes its place. */
const SHOWN_MS = 3500;

export interface QuestNotice {
  kicker: string;
  name: string;
  detail?: string;
  icon: 'quest-available' | 'quest-ready';
}

/**
 * A quest taken, finished or turned in (ADR 0047): the gold plate of the
 * achievements' notice at the top of the screen, one at a time.
 */
export class QuestToast {
  private readonly root = element('div', 'achievement-toast quest-toast');
  private readonly queue: QuestNotice[] = [];
  private timer: number | undefined;

  constructor() {
    this.root.hidden = true;
    this.root.setAttribute('role', 'status');
    this.root.setAttribute('aria-live', 'polite');
    document.body.append(this.root);
  }

  show(notice: QuestNotice): void {
    this.queue.push(notice);
    if (this.timer === undefined) this.next();
  }

  private next(): void {
    const notice = this.queue.shift();
    if (notice === undefined) {
      this.root.hidden = true;
      this.timer = undefined;
      return;
    }
    const text = element('div', 'achievement-toast__text');
    text.append(
      element('span', 'achievement-toast__kicker', notice.kicker),
      element('span', 'achievement-toast__name', notice.name),
    );
    if (notice.detail !== undefined) {
      text.append(element('span', 'achievement-toast__title', notice.detail));
    }
    this.root.replaceChildren(kitIcon(notice.icon), text);
    this.root.hidden = false;
    this.root.classList.remove('achievement-toast--in');
    requestAnimationFrame(() => {
      this.root.classList.add('achievement-toast--in');
    });
    this.timer = window.setTimeout(() => {
      this.next();
    }, SHOWN_MS);
  }

  destroy(): void {
    window.clearTimeout(this.timer);
    this.root.remove();
  }
}
